import { useState } from 'react';
import { Button, Nav, Tab } from 'react-bootstrap';
import Contribution from '../home/contribution/Contribution';
import Deposit_History_list_contant from './deposit_tab_contant/deposit_History_list_contant/Deposit_History_list_contant';
import Deposit_tab_contant from './deposit_tab_contant/Deposit_tab_contant';
import "./Recharge_wallate.css";
import Withdraw_History_list_contant from './withdraw_tab_contant/withdraw_History_list_contant/Withdraw_History_list_contant';
import Withdraw_tab_contant from './withdraw_tab_contant/Withdraw_tab_contant';

function Recharge_wallate() {
    const [activeTab, setActiveTab] = useState("deposit");
    const [showHistory, setShowHistory] = useState(false);


    return (
        <>
            <section className="Recharge_wallate inner_section_box">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-9 col-md-11">
                            {/* ===== WALLET HEADER ===== */}
                            <div className="wallet-header">
                                <div className="wallet-header-left">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <h3 className="wallet-title">TOTAL <br /> CAPITAL AMOUNT</h3>
                                        </div>

                                        <div className="col-sm-6">
                                            <h2 className="wallet-amount">₹ 4,579,031</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="wallet-header-right">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="wallet-profit">
                                                <p>Today's Profit</p>
                                                <h4>₹ 6,790</h4>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="wallet-current">
                                                <p>Current Amount</p>
                                                <h4>₹ 45,790,3143</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ===== WALLET ACTION (TABS) ===== */}
                            <div className="wallet-action">
                                <Tab.Container
                                    id="wallet-tabs"
                                    activeKey={activeTab}
                                    onSelect={(key) => setActiveTab(key)}
                                >
                                    <Nav variant="pills" className="wallet-tabs">
                                        <Nav.Item>
                                            <Nav.Link className='tab-btn' eventKey="deposit">
                                                <div className="tab_img_holder"><img src="/assets/images/wallate/recharge_wallate/wallet_tabs_img/wallet.png" alt="" className='tab_img' />
                                                </div>
                                                Deposit
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link className='tab-btn' eventKey="withdraw">
                                                <div className="tab_img_holder">
                                                    <img src="/assets/images/wallate/recharge_wallate/wallet_tabs_img/withdraw.png" alt="" className='tab_img' />
                                                </div>
                                                Withdraw
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>

                                    <Tab.Content>
                                        <Tab.Pane eventKey="deposit">
                                            <Deposit_tab_contant />
                                        </Tab.Pane>

                                        <Tab.Pane eventKey="withdraw">
                                            <Withdraw_tab_contant />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Tab.Container>
                            </div>

                            {/* ===== HISTORY LIST HOLDER ===== */}
                            <div className="history_list_holder">
                                <div className="wallet-action">
                                    <Button
                                        className="Show_history"
                                        onClick={() => setShowHistory(!showHistory)}
                                    >
                                        {showHistory ? "Hide History" : "Show History"}
                                    </Button>
                                    {showHistory && (
                                        activeTab === "deposit" ? (
                                            <Deposit_History_list_contant />
                                        ) : (
                                            <Withdraw_History_list_contant />
                                        )
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Contribution />
        </>
    );
}

export default Recharge_wallate;
